import '~/stylesheets/base/_offcanvas.scss';
import BlueArrow from '~/images/arrow-right-blue-circle.svg';
import YellowArrow from '~/images/arrow-right-yellow-circle.svg';
import cx from 'classnames';
import store from '~/javascripts/store.js';
import { isUkSite, usOrUkUrlFor } from '~/javascripts/utils/localization';
import { observer } from 'mobx-react';

const OffCanvasNav = observer(
  ({ currentUserPresent, signInParams, userHasOpenCampaigns, userSlug }) => {
    const handleNavHeaderClick = (section) => {
      store.nav.offCanvasActiveSection =
        store.nav.offCanvasActiveSection == section ? '' : section;
    };

    return (
      <nav className='right-off-canvas-menu theme-design-system-v1 bg-cw-brand-yellow-100'>
        <ul className='off-canvas-list'>
          {currentUserPresent && (
            <li
              className={cx(
                'nav-section p-6 border-b border-solid border-grey-50 bg-cw-brand-yellow-300',
                {
                  active: store.nav.offCanvasActiveSection == 'account',
                }
              )}
            >
              <div
                className='nav-section-header flex items-center justify-between cursor-pointer'
                onClick={() => handleNavHeaderClick('account')}
              >
                <div className='heading-xs'>Account</div>
                <span className='icn cw-icon-plus-sm bg-cw-white border border-cw-brand-grey-800 rounded-full flex items-center justify-center' />
              </div>

              <div className='subnav mt-5'>
                <a className='block heading-m my-5' href={`/${userSlug}`}>
                  My Profile
                </a>

                <a
                  className='block heading-m my-5'
                  href='/account/giving-history'
                >
                  My Dashboard
                </a>

                {userHasOpenCampaigns ? (
                  <a
                    className='block heading-m my-5'
                    href='/account/fundraisers'
                  >
                    My Fundraisers
                  </a>
                ) : (
                  <a className='block heading-m my-5' href='#start-fundraiser'>
                    Start a Fundraiser
                  </a>
                )}

                <a className='block heading-m my-5' href='/account/settings'>
                  Account Settings
                </a>

                <a
                  className='block heading-m mt-5'
                  data-method='delete'
                  href='/account/logout'
                >
                  Sign Out
                </a>
              </div>
            </li>
          )}

          <li
            className={cx(
              'nav-section p-6 border-b border-solid border-grey-50',
              {
                active: store.nav.offCanvasActiveSection == 'take-action',
              }
            )}
          >
            <div
              className='nav-section-header flex items-center justify-between cursor-pointer'
              onClick={() => handleNavHeaderClick('take-action')}
            >
              <div className='heading-xs'>Take Action</div>
              <span className='icn cw-icon-plus-sm bg-cw-white border border-cw-brand-grey-800 rounded-full flex items-center justify-center' />
            </div>

            <div className='subnav mt-8'>
              <a
                className='cw-link--primary'
                href={usOrUkUrlFor('/get-involved')}
              >
                See all ways to make an impact
              </a>

              <a
                className='subnav-item bg-cw-brand-yellow-300 flex items-center justify-between p-2 mt-8 mb-5'
                href={usOrUkUrlFor('/donate/the-spring')}
              >
                <div className='mr-2'>
                  <div className='heading-m mb-1'>Give Monthly</div>
                  <div className='body-m'>
                    Join the global community serving people with clean water
                    every&nbsp;month.
                  </div>
                </div>
                <img src={YellowArrow} />
              </a>

              <a
                className='subnav-item bg-cw-brand-yellow-300 flex items-center justify-between p-2 my-5'
                href={usOrUkUrlFor('/fundraise')}
              >
                <div className='mr-2'>
                  <div className='heading-m mb-1'>
                    Fundraise for clean water
                  </div>
                  <div className='body-m'>
                    Support clean water projects by raising funds for people
                    in&nbsp;need.
                  </div>
                </div>
                <img src={YellowArrow} />
              </a>

              <a
                className='subnav-item bg-cw-brand-yellow-300 flex items-center justify-between p-2 my-5'
                href={usOrUkUrlFor('/donate/water-project-sponsorship')}
              >
                <div className='mr-2'>
                  <div className='heading-m mb-1'>Sponsor a water project</div>
                  <div className='body-m'>
                    Transform an entire community or school with a gift of
                    {isUkSite() ? ' £8,500 ' : ' $10,000 '}
                    or&nbsp;more.
                  </div>
                </div>
                <img src={YellowArrow} />
              </a>

              <a
                className='subnav-item bg-cw-brand-yellow-300 flex items-center justify-between p-2 my-5'
                href={usOrUkUrlFor('/partnerships')}
              >
                <div className='mr-2'>
                  <div className='heading-m mb-1'>Become a brand partner</div>
                  <div className='body-m'>
                    Work closely with our team to develop initiatives with
                    undeniable&nbsp;impact.
                  </div>
                </div>
                <img src={YellowArrow} />
              </a>

              {!isUkSite() && (
                <a
                  className='subnav-item bg-cw-brand-yellow-300 flex items-center justify-between p-2 my-5'
                  href='/the-tributary'
                >
                  <div className='mr-2'>
                    <div className='heading-m mb-1'>Plan legacy giving</div>
                    <div className='body-m'>
                      Make a lasting gift to help bring clean water to every
                      person on the&nbsp;planet.
                    </div>
                  </div>
                  <img src={YellowArrow} />
                </a>
              )}

              <a
                className='subnav-item bg-cw-brand-yellow-300 flex items-center justify-between p-2 my-5'
                href='/experience'
              >
                <div className='mr-2'>
                  <div className='heading-m mb-1'>Visit the Experience Lab</div>
                  <div className='body-m'>
                    Explore humanity’s search for water through virtual reality,
                    holograms, and immersive video.
                  </div>
                </div>
                <img src={YellowArrow} />
              </a>
            </div>
          </li>

          <li
            className={cx(
              'nav-section p-6 border-b border-solid border-grey-50',
              {
                active: store.nav.offCanvasActiveSection == 'about',
              }
            )}
          >
            <div
              className='nav-section-header flex items-center justify-between cursor-pointer'
              onClick={() => handleNavHeaderClick('about')}
            >
              <div className='heading-xs'>About Us</div>
              <span className='icn cw-icon-plus-sm bg-cw-white border border-cw-brand-grey-800 rounded-full flex items-center justify-center' />
            </div>

            <div className='subnav mt-8'>
              <a className='cw-link--primary' href={usOrUkUrlFor('/about')}>
                Explore charity: water at a glance
              </a>

              <a
                className='subnav-item bg-cw-brand-yellow-300 flex items-center justify-between p-2 mt-8 mb-5'
                href='/our-approach/100-percent-model'
              >
                <div className='mr-2'>
                  <div className='heading-m mb-1'>The 100% Model</div>
                  <div className='body-m'>
                    Learn how donors cover our operations, so 100% of donations
                    fund clean&nbsp;water.
                  </div>
                </div>
                <img src={YellowArrow} />
              </a>

              <a
                className='subnav-item bg-cw-brand-yellow-300 flex items-center justify-between p-2 my-5'
                href={usOrUkUrlFor('/our-work')}
              >
                <div className='mr-2'>
                  <div className='heading-m mb-1'>Our work</div>
                  <div className='body-m'>
                    See our funded water projects and proof of&nbsp;impact.
                  </div>
                </div>
                <img src={YellowArrow} />
              </a>

              <a
                className='subnav-item bg-cw-brand-yellow-300 flex items-center justify-between p-2 my-5'
                href={usOrUkUrlFor('/how-we-work')}
              >
                <div className='mr-2'>
                  <div className='heading-m mb-1'>How we work</div>
                  <div className='body-m'>
                    Learn about how we build long-term sustainable
                    water&nbsp;projects.
                  </div>
                </div>
                <img src={YellowArrow} />
              </a>

              <a
                className='subnav-item bg-cw-brand-yellow-300 flex items-center justify-between p-2 my-5'
                href='/about/scott-harrison-story'
              >
                <div className='mr-2'>
                  <div className='heading-m mb-1'>Meet the founder</div>
                  <div className='body-m'>
                    See how Scott Harrison&apos;s decision to reset his life
                    inspired charity:&nbsp;water.
                  </div>
                </div>
                <img src={YellowArrow} />
              </a>

              <a
                className='subnav-item bg-cw-brand-yellow-300 flex items-center justify-between p-2 my-5'
                href='/about/financials'
              >
                <div className='mr-2'>
                  <div className='heading-m mb-1'>See our financials</div>
                  <div className='body-m'>
                    Learn how your gift is being used to bring clean water to
                    people who need&nbsp;it.
                  </div>
                </div>
                <img src={YellowArrow} />
              </a>
            </div>
          </li>

          <li className='nav-section p-6 border-b border-solid border-grey-50'>
            <a
              className='nav-section-header flex items-center justify-between cursor-pointer'
              href={usOrUkUrlFor('/global-water-crisis')}
            >
              <div className='heading-xs'>Why Water?</div>
              <img src={BlueArrow} />
            </a>
          </li>

          {!currentUserPresent && (
            <div className='p-6 pt-8'>
              <a
                className='flex items-center mb-5'
                href={`/account/login${signInParams}`}
              >
                <div className='icon cw-icon-user-outline mr-2' />
                <div className='heading-s'>Sign in</div>
              </a>

              <a
                className='flex items-center'
                href='/mailing_list_subscribers/new'
              >
                <div className='icon cw-icon-mail-outline mr-2' />
                <div className='heading-s'>
                  Get our emails to stay in the know
                </div>
              </a>
            </div>
          )}
        </ul>
      </nav>
    );
  }
);

export default OffCanvasNav;
